import { type LOAN_REQUEST_COMMAND, LOAN_REQUEST_COMMANDS } from 'cpool-constants';

import type { SchemaExpensesForm } from '~/features/leadDetails/schemas/expenses.schema.ts';

export type ExpenseType = keyof SchemaExpensesForm;

type ExpenseTypeConfig = {
    addCommand: LOAN_REQUEST_COMMAND;
    changeCommand: LOAN_REQUEST_COMMAND;
    label: 'EXPENSES.ALIMENT' | 'EXPENSES.OTHER' | 'EXPENSES.PRIVATE_HEALTH_INSURANCE' | 'EXPENSES.RENTAL';
    removeCommand: LOAN_REQUEST_COMMAND;
};

export const expenseTypeConfig: Record<ExpenseType, ExpenseTypeConfig> = {
    mietausgaben: {
        addCommand: LOAN_REQUEST_COMMANDS.addExpenseRental,
        changeCommand: LOAN_REQUEST_COMMANDS.changeExpenseRental,
        label: 'EXPENSES.RENTAL',
        removeCommand: LOAN_REQUEST_COMMANDS.removeExpenseRental,
    },
    privateKrankenversicherungen: {
        addCommand: LOAN_REQUEST_COMMANDS.addExpensePrivateHealthInsurance,
        changeCommand: LOAN_REQUEST_COMMANDS.changeExpensePrivateHealthInsurance,
        label: 'EXPENSES.PRIVATE_HEALTH_INSURANCE',
        removeCommand: LOAN_REQUEST_COMMANDS.removeExpensePrivateHealthInsurance,
    },
    sonstigeAusgaben: {
        addCommand: LOAN_REQUEST_COMMANDS.addExpenseOther,
        changeCommand: LOAN_REQUEST_COMMANDS.changeExpenseOther,
        label: 'EXPENSES.OTHER',
        removeCommand: LOAN_REQUEST_COMMANDS.removeExpenseOther,
    },
    unterhaltsverpflichtungen: {
        addCommand: LOAN_REQUEST_COMMANDS.addExpenseObligationToSupport,
        changeCommand: LOAN_REQUEST_COMMANDS.changeExpenseObligationToSupport,
        label: 'EXPENSES.ALIMENT',
        removeCommand: LOAN_REQUEST_COMMANDS.removeExpenseObligationToSupport,
    },
};

export const expenseListOrder: ExpenseType[] = [
    'sonstigeAusgaben',
    'unterhaltsverpflichtungen',
    'mietausgaben',
    'privateKrankenversicherungen',
];

export const expenseAddButtonOrder: ExpenseType[] = [
    'unterhaltsverpflichtungen',
    'mietausgaben',
    'privateKrankenversicherungen',
    'sonstigeAusgaben',
];
